// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"366648093364abeec168","293":"48660eefc083a818b92f","452":"0dc1492ad851e35ff0fd","454":"9cd3306868733e1620ae","551":"a0d2992e99d6d57e8986"}[chunkId] + ".js";
};